import { render } from "./socialMediaItemComponent.vue?vue&type=template&id=f72bbe34&scoped=true&ts=true"
import script from "./socialMediaItemComponent.vue?vue&type=script&lang=ts"
export * from "./socialMediaItemComponent.vue?vue&type=script&lang=ts"

import "./socialMediaItemComponent.vue?vue&type=style&index=0&id=f72bbe34&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f72bbe34"]])

export default __exports__